import ls from '@/storage/index'
import { router } from '@/route/index.js'
import mitt from 'mitt'

// 创建事件总线实例
const emitter = mitt()

emitter.on('request:401', async () => {
  // 直接清除 token，避免循环依赖
  ls.remove('token')
  ls.remove('refreshToken')
  
  // 等待路由就绪后跳转登录页
  await router.isReady()
  router.replace({
    name: 'login',
  })
})

export default emitter
